import styled from 'styled-components';

import { colors, cssBreakpoints, fontWeights } from 'theme/theme';

export const ViewJobPageSidebarResultsHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  /* Add padding to avoid cutting off box-shadow */
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;

  &::after {
    content: '';
    background: linear-gradient(
      180deg,
      rgb(251 251 251 / 23.63%),
      rgb(255 255 255 / 86.77%)
    );
    height: 66px;
    pointer-events: none;
    position: sticky;
    width: 100%;
    bottom: 0;
  }
`;

export const ViewJobPageSidebarResultsHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
`;

export const ViewJobPageSidebarResultsHeaderTitle = styled.h4`
  display: none;
  font-size: 16px;
  color: ${colors.mediumContentGrey};
  font-weight: ${fontWeights.normal};
  margin: 0;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    display: block;
  }
`;
